import React from "react";
import MenuContextProvider from "@/context/menu-context";
import SearchContextProvider from "@/context/search-context";
import Layout from "@/components/layout";
import Menu from "@/components/header-one";
import Footer from "@/components/footer";
import ContentMesquita from "@/components/ContentMesquita";
import SEO from '../components/seo'

const Mesquita = () => {
  return (
    <MenuContextProvider>
      <SearchContextProvider>
        <Layout>
          <SEO
            title="Sobre Nós - Conexão com a Mesquita e apoio das lideranças religiosas"
            pathname="/"
          />
          <Menu />
          <ContentMesquita />
          <Footer /> 
        </Layout>
      </SearchContextProvider>
    </MenuContextProvider>
  )
}

export default Mesquita;
